// extracted by mini-css-extract-plugin
module.exports =  {"block":"zHp3lqUOAed8PDgaAor2","input":"vAuK970CU456wEcOxt93","vertical":"CkyyoOQNJd5aKgSkVelQ","standard":"eaUwYu9eoyjT7A3PF_ZA","horizontal":"R6f0GpTPgkmB2jK9JvTl"};